export default __webpack_public_path__ + "static/media/icn_sale_shop_store.ab373a04.svg";